import React, { useRef, useState, useEffect } from 'react'
import CloseIcon from '../Icons/CloseIcon'
import { useHorizontalDragHoverScroll } from '../../../hooks/useHorizontalDragHoverScroll'
import { ACCEPTED_IMAGE_TYPES } from '@/constants'

const UploadWrapper = ({
  files = [],
  onRemoveFile,
  className = ''
}) => {
  if (files.length === 0) return null;

  // Create ref for the container
  const containerRef = useRef(null);
  const [imagePreviews, setImagePreviews] = useState({});

  // Use horizontal drag scroll without auto-scroll
  const { scrollToEnd } = useHorizontalDragHoverScroll(containerRef, {
    enableDragScroll: true,
    enableHoverScroll: false // Disable auto-scroll
  });

  // Helper function to get file extension and type
  const getFileInfo = (file) => {
    const name = file.name || 'unknown';
    const extension = name.split('.').pop()?.toUpperCase() || 'FILE';
    return { name, extension };
  };

  // Helper function to check if file is an image
  const isImageFile = (file) => {
    return ACCEPTED_IMAGE_TYPES.includes(file.type);
  };

  // Create image previews for image files
  useEffect(() => {
    const newPreviews = {};
    
    files.forEach((file, index) => {
      if (isImageFile(file)) {
        const previewUrl = URL.createObjectURL(file);
        newPreviews[index] = previewUrl;
      }
    });

    setImagePreviews(newPreviews);

    // Cleanup function to revoke object URLs
    return () => {
      Object.values(newPreviews).forEach(url => URL.revokeObjectURL(url));
    };
  }, [files]);

  // Cleanup image previews when component unmounts
  useEffect(() => {
    return () => {
      Object.values(imagePreviews).forEach(url => URL.revokeObjectURL(url));
    };
  }, [imagePreviews]);



  return (
    <div className={`py-v3-sm pl-v3-sm bg-white rounded-b-v3-xl border border-v3-black-inactive ${className}`}>
      <div
        ref={containerRef}
        className="flex gap-v3-xs overflow-x-auto scrollbar-hide"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
      >
        {files.map((file, index) => {
          const { extension } = getFileInfo(file);
          const isImage = isImageFile(file);
          const previewUrl = imagePreviews[index];

          return (
            <div
              key={index}
              className={`relative group flex-shrink-0  ${index === files.length - 1 ? 'mr-v3-sm' : ''}`}
            >
              <div className="w-[70px] h-[70px] mt-1 bg-v3-black-inactive/5 border border-v3-black-inactive hover:border-v3-black-secondary  flex flex-col overflow-hidden rounded-v3-lg ">
              
                <div className="flex-1 flex items-center justify-center w-full h-full relative ">
                  {/* {isImage && previewUrl ? (
                    <img
                      src={previewUrl}
                      alt={`Preview of ${file.name}`}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        // Fallback if image fails to load
                        e.target.style.display = 'none';
                      }}
                    />
                  ) : ( */}
                    <div className="w-full h-full flex  justify-center bg-v3-black-inactive/10 p-1">
                      <span className="text-[8px] font-medium text-v3-black-heading text-center break-all line-clamp-3 leading-tight">
                        {file.name}
                      </span>
                    </div>
                  {/* )} */}
                </div>

                <div className="absolute bottom-0 left-0 right-0  w-full  text-center bg-white border  border-v3-black-inactive group-hover:border-v3-black-secondary rounded-v3-lg">
                  <span className="text-xs font-bold uppercase text-v3-black-dark">{extension}</span>
                </div>

            
                <button
                  onClick={() => onRemoveFile && onRemoveFile(index)}
                  className="absolute -top-0 -right-1 bg-white  rounded-full border border-v3-black-secondary w-[20px] h-[20px] p-v3-xxs flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200  "
                >
                  <CloseIcon />
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  )
}

export default UploadWrapper